import { cn } from '@commenda/utils';
import React from 'react';

export interface DataGridCellNumericProps {
  value: React.ReactNode;
  unit?: React.ReactNode;
  unitTrailing?: React.ReactNode;
  className?: string;
}

const DATA_GRID_NUMERIC_UNIT_CLASS_NAMES =
  'txt-small-regular shrink-0 text-text-quaternary';

const DataGridCellNumeric = ({
  value,
  unit,
  unitTrailing,
  className,
}: DataGridCellNumericProps) => (
  <div className={cn('flex w-full items-center gap-xs', className)}>
    {unit ? (
      <span className={DATA_GRID_NUMERIC_UNIT_CLASS_NAMES}>{unit}</span>
    ) : null}
    <span className="txt-small-regular min-w-0 flex-1 truncate text-right text-text-primary">
      {value}
    </span>
    {unitTrailing ? (
      <span className={DATA_GRID_NUMERIC_UNIT_CLASS_NAMES}>{unitTrailing}</span>
    ) : null}
  </div>
);

export { DataGridCellNumeric };
